import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

const { state } = store('gt/menu', {
    actions: {

        clickOutside: (e) => {
            const element = getElement();
            const menuMobile = document.querySelector('.gt-menu__mobile');
            if (element.ref.contains(e.target) || menuMobile.contains(e.target)) return;
            store('gt/menu').actions.closeMenu();
            store('gt/menu').actions.closeSubMenuMobile();
        },
        scroll: () => {
            if (!state.isSticky) return;

            const currentScrollY = window.scrollY;

            // Gestion de la stickiness
            if (currentScrollY > state.headerBottom) {
                if (!state.sticked) {
                    document.querySelector('.wp-site-blocks').style.paddingTop = `${state.headerHeight}px`;
                    state.sticked = true;
                }
            } else {
                document.querySelector('.wp-site-blocks').style.paddingTop = '0px';
                state.sticked = false;
                state.stickedDown = false;
            }

            if (state.onlyOnScrollUp) {
                if (state.lastScrollY > currentScrollY) {
                    state.stickedDown = true;
                } else {
                    state.stickedDown = false;
                }
            } else {
                state.stickedDown = true;
            }
            // Détection du scroll vers le bas
            if (currentScrollY > state.lastScrollY) {
                // Fermer le menu si on scroll vers le bas
                if (state.isOpen) {
                    store('gt/menu').actions.closeSubMenuMobile();
                    store('gt/menu').actions.closeMenu();
                    state.isOpen = false; // Assurez-vous que cet état est mis à jour
                }
            }

            state.lastScrollY = currentScrollY;
        },
        toggleMenuMobile: () => {
            state.isMenuMobileOpen = !state.isMenuMobileOpen;

            if (state.isOpen) {
                state.isOpen = false;
                document.body.classList.remove('gt-popup-toggled', 'gt-menu-toggled');
                state.submenusMobile.forEach((submenu, key) => {
                    state.submenusMobile[key].isOpen = false;
                });
                state.isOpen = false;
            }

        },
        init: () => {

            const element = getElement();
            state.headerBottom = element.ref.offsetTop + element.ref.offsetHeight + (16 * 1.2);
            state.headerHeight = element.ref.offsetHeight + (16 * 1.2);

            // Set active menu
            state.submenus.forEach((submenu) => {
                const links = submenu.content.match(/href="([^"]*)"/g);
                if (links) {
                    links.forEach(link => {
                        const url = link.match(/href="([^"]*)"/)[1];
                        const cleanUrl = url.split('?')[0];
                        const cleanCurrentUrl = window.location.href.split('?')[0];
                        if (cleanUrl === cleanCurrentUrl) {
                            state.menus[submenu.parentId].isCurrent = true;
                        }
                    });
                }
            });
        },
        closeMenu: () => {
            if (state.isOpen) {
                state.isOpen = false;
                document.body.classList.remove('gt-popup-toggled', 'gt-menu-toggled');
                state.submenus.forEach((submenu, key) => {
                    submenu[key].isOpen = false;
                });
                document.querySelectorAll('li.gt-menu__list__item .active').forEach((el) => {
                    el.classList.remove('active');
                    el.setAttribute('aria-expanded', 'false');
                });
            }
        },
        toggleMenu: () => {
            state.isMenuOpen = !state.isMenuOpen;
        },

        toggleSubmenuMobile: (e) => {

            state.isOpen = true
            const element = getElement();

            if (!element.ref.getAttribute('href')) {
                e.preventDefault();
            }

            // Add class to body
            document.body.classList.add('gt-popup-toggled');
            document.body.classList.add('gt-menu-toggled');

            // Display submenu logic
            const controls = element.ref.getAttribute('aria-controls');

            Object.keys(state.menusMobile).forEach((key) => {
                const menu = state.menusMobile[key];
                if (menu.controls === controls) {
                    state.currentMenuMobile = menu.title;
                    state.menusMobile[key].isOpen = true;
                    state.focusedMenu = element.ref;
                }
                else {
                    state.menusMobile[key].isOpen = false;
                }
            });

            const subMenuWrapper = document.getElementById(controls);

            state.submenusMobile.forEach((submenu, key) => {
                if (submenu.id === controls) {
                    subMenuWrapper.innerHTML = submenu.content;
                    state.submenusMobile[key].isOpen = true;
                    state.focusTrapElement = subMenuWrapper;
                }
                else {
                    subMenuWrapper.parentNode.querySelectorAll('.gt-menu__mobile__submenu').forEach((submenu) => {
                        if (submenu.id !== controls) {
                            submenu.innerHTML = '';
                        }
                    });
                    state.submenusMobile[key].isOpen = false;
                }
            });

            if (state.isMobile && window.matchMedia('(max-width: 768px)').matches) {
                if (element.ref.getAttribute('href')) return;
                const mobileMenus = document.querySelector('.gt-menu__mobile__menus');
                if (mobileMenus) {
                    mobileMenus.style.marginLeft = `-100%`;
                }
            }


        },
        closeSubMenuMobile: () => {
            state.isOpen = false;
            document.body.classList.remove('gt-popup-toggled', 'gt-menu-toggled');
            state.submenusMobile.forEach((submenu, key) => {
                state.submenusMobile[key].isOpen = false;
                let subMenuWrapper = document.getElementById(submenu.id);
                if (subMenuWrapper) {
                    subMenuWrapper.innerHTML = '';
                }
            });
            state.currentMenuMobile = '';

            if (state.isMobile) {
                const mobileMenus = document.querySelector('.gt-menu__mobile__menus');
                if (mobileMenus) {
                    mobileMenus.style.marginLeft = `0px`;
                }
            }

        },
        toggleSubmenu: (e) => {


            if (state.activatedHover && e.type === 'click') return;
            if (!state.activatedHover && (e.type != "click")) return;

            state.isOpen = true
            const element = getElement();

            // Add class to body
            document.body.classList.add('gt-popup-toggled');
            document.body.classList.add('gt-menu-toggled');

            // Display submenu logic
            const controls = element.ref.getAttribute('aria-controls');

            Object.keys(state.menus).forEach((key) => {
                const menu = state.menus[key];
                if (menu.controls === controls) {
                    state.menus[key].isOpen = true;
                    state.focusedMenu = element.ref;
                }
                else {
                    state.menus[key].isOpen = false;
                }
            });

            const subMenuWrapper = document.getElementById(controls);

            state.submenus.forEach((submenu, key) => {
                if (submenu.id === controls) {
                    subMenuWrapper.innerHTML = submenu.content;
                    if (state.isMenuOpen) {
                        element.ref.parentNode.appendChild(subMenuWrapper.parentNode);
                    }
                    state.submenus[key].isOpen = true;

                    const firstFocusable = subMenuWrapper.querySelector('button, a');
                    if (firstFocusable) {
                        setTimeout(() => {
                            firstFocusable.focus();
                        }, 5);
                    }

                    state.focusTrapElement = subMenuWrapper;
                }
                else {
                    state.submenus[key].isOpen = false;
                }
            });

        },



        focusTrap: (event) => {
            if (!state.isOpen) return;

            if (event.key === 'Escape') {
                event.preventDefault();
                state.isOpen = false;
                document.body.classList.remove('gt-popup-toggled', 'gt-menu-toggled');
                state.submenus.forEach((submenu, key) => {
                    state.submenus[key].isOpen = false;
                });
                Object.keys(state.menus).forEach((key) => {
                    const menu = state.menus[key];
                    state.menus[key].isOpen = false;
                });
                state.focusedMenu.focus();
                return;
            }

            if (event.key === 'Tab') {
                const focusableElements = Array.from(state.focusTrapElement.querySelectorAll(
                    'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
                )).filter(el => !el.disabled && el.offsetParent !== null);

                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (event.shiftKey && document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                } else if (!event.shiftKey && document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        },
    },
    callbacks: {
        checkBreakpoint: () => {

            if (window.matchMedia(`(max-width: ${state.breakpoint}px)`).matches) {
                state.isMobile = true;
                if (state.showIconsOnlyMobile) {
                    state.showIcons = true;
                }
                if (state.showSubtitlesOnlyMobile) {
                    state.showSubtitles = true;
                }
                if (state.showIconsOnlyDesktop) {
                    state.showIcons = false;
                }
                if (state.showSubtitlesOnlyDesktop) {
                    state.showSubtitles = false;
                }
            } else {
                state.isMobile = state.onlyBurger ? true : false;
                if (state.showIconsOnlyMobile) {
                    state.showIcons = false;
                }
                if (state.showSubtitlesOnlyMobile) {
                    state.showSubtitles = false;
                }
                if (state.showIconsOnlyDesktop) {
                    state.showIcons = true;
                }
                if (state.showSubtitlesOnlyDesktop) {
                    state.showSubtitles = true;
                }
            }
            console.log(state);
        }
    }
});